var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTestAttented(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F3E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14C17.8798 14 19 15.1202 19 16.5C19 17.8798 17.8798 19 16.5 19C15.1202 19 14 17.8798 14 16.5C14 15.1202 15.1202 14 16.5 14ZM28 14C29.3798 14 30.5 15.1202 30.5 16.5C30.5 17.8798 29.3798 19 28 19C26.6202 19 25.5 17.8798 25.5 16.5C25.5 15.1202 26.6202 14 28 14ZM12 23.3344C12 21.4938 13.4937 20 15.3344 20H16.6688C17.1656 20 17.6375 20.1094 18.0625 20.3031C18.0219 20.5281 18.0031 20.7625 18.0031 21C18.0031 22.1938 18.5281 23.2656 19.3563 24C19.35 24 19.3438 24 19.3344 24H12.6656C12.3 24 12 23.7 12 23.3344ZM24.6656 24C24.6594 24 24.6531 24 24.6438 24C25.475 23.2656 25.9969 22.1938 25.9969 21C25.9969 20.7625 25.975 20.5312 25.9375 20.3031C26.3625 20.1063 26.8344 20 27.3313 20H28.6656C30.5063 20 32 21.4938 32 23.3344C32 23.7031 31.7 24 31.3344 24H24.6656ZM19 21C19 19.3443 20.3443 18 22 18C23.6557 18 25 19.3443 25 21C25 22.6557 23.6557 24 22 24C20.3443 24 19 22.6557 19 21ZM16 29.1656C16 26.8656 17.8656 25 20.1656 25H23.8344C26.1344 25 28 26.8656 28 29.1656C28 29.625 27.6281 30 27.1656 30H16.8344C16.375 30 16 29.6281 16 29.1656Z",
    fill: "#6B46C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTestAttented);
export default __webpack_public_path__ + "static/media/ic_test_attented.446fd7802e607286ca0227dbf49447b5.svg";
export { ForwardRef as ReactComponent };